import { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { api, formatApiError } from "../lib/api";
import { Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="App bg-[#F4F7FA] min-h-screen">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-20">
        <div className="flex items-center gap-2 mb-2"><Mail className="w-6 h-6 text-mint-dark" /><h1 className="text-2xl font-bold font-heading text-navy">Reset your password</h1></div>
        {sent ? (
          <div className="mt-6 bg-white rounded-2xl border border-slate-200 p-8 text-center shadow-sm" data-testid="forgot-success">
            <CheckCircle2 className="w-12 h-12 text-mint mx-auto" />
            <p className="mt-3 text-slate-600">If an account exists for <span className="font-semibold">{email}</span>, we've sent a password reset link. Please check your inbox.</p>
            <Link to="/login" className="mt-5 inline-block text-mint-dark font-semibold">Back to log in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 bg-white rounded-2xl border border-slate-200 p-6 shadow-sm flex flex-col gap-4" data-testid="forgot-form">
            <p className="text-sm text-slate-600">Enter your email and we'll send you a link to reset your password.</p>
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
              className="w-full border border-slate-300 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-mint" />
            {error && <p className="text-sm text-destructive" data-testid="forgot-error">{error}</p>}
            <button data-testid="forgot-submit" disabled={loading} className="bg-mint text-white font-semibold py-3 rounded-xl hover:bg-mint-dark transition-colors disabled:opacity-60">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
